module.exports = __webpack_public_path__ + "media/custom/images/img36-8dd63b68100a6dad10892e8da632ff5f.jpg";